import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

const { BRAND_NAME } = process.env;

const ProFooter = () => {
	const classes = useStyles("Pro");
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<React.Fragment>
			<Box
				component="section"
				className={classes.proFooter}
				display={"flex"}
				flexDirection={{
					xs: "column-reverse",
					sm: "column-reverse",
					md: "row-reverse",
				}}
				alignItems={"center"}
				justifyContent={"center"}
			>
				<Box
					display={"flex"}
					flexDirection={"column"}
					flex={"50%"}
					alignItems={"center"}
					justifyContent={"center"}
					textAlign={"center"}
					height={"100%"}
					width={"100%"}
					position={"relative"}
					bgcolor={"#000"}
					color={"#FFF"}
					p={6}
				>
					<h2 className={classes.readyH2}>
						Get more customers with {BRAND_NAME}
					</h2>

					<div className={classes.readySubText}>
						Join us. We’ll help you every step
						<br />
						of the way.
					</div>

					<Box component={"div"} textAlign={"center"}>
						<Button
							variant="contained"
							size={"large"}
							color="primary"
							disableElevation
							onClick={scrollToTop}
						>
							Let’s go!
						</Button>
					</Box>
				</Box>
				<Box
					height={"100%"}
					display={"flex"}
					flex={"50%"}
					position={"relative"}
				>
					<Box
						height={"100%"}
						overflow={"hidden"}
						position={"relative"}
						width={"100%"}
					>
						<video
							className={classes.readyVideo}
							autoPlay
							loop
							crossOrigin="anonymous"
							muted
							playsInline=""
							preload="none"
						>
							<source
								src="//static.tutors.com/assets/images/misc/1077583892-hd.mp4"
								type="video/mp4"
							/>
						</video>
					</Box>
				</Box>
			</Box>

			<Box
				component="section"
				className={classes.proFooter}
				display={"none"}
				flexDirection={"row-reverse"}
				alignItems={"center"}
				justifyContent={"center"}
			>
				<Grid container>
					<Grid item xs={12} sm={6}>
						<Box
							position={"absolute"}
							top={0}
							left={0}
							minHeight={"100%"}
							minWidth={"100%"}
						>
							<video id="earth" preload="auto" autoPlay="" loop="" muted="">
								<source
									src="//static.homeguide.com/assets/images/boat_on_the_lake2.mp4?2"
									type="video/mp4"
								/>
							</video>
						</Box>
					</Grid>
					<Grid item xs={12} sm={6}>
						<div className={classes.proFooterCTA}>
							<h2 className={classes.readyH2}>
								Try tutoring on
								<br />
								Tutors.com
							</h2>

							<div className={classes.readySubText}>
								Join us. We’ll help you every step
								<br />
								of the way.
							</div>

							<Box component={"div"} textAlign={"center"}>
								<Button
									variant="contained"
									size={"large"}
									color="primary"
									disableElevation
									onClick={scrollToTop}
								>
									Let’s go!
								</Button>
							</Box>
						</div>
					</Grid>
				</Grid>
			</Box>
		</React.Fragment>
	);
};

export default ProFooter;
